import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';

const UsageTypeDropdown = ({
    currentCompany,
    accountScope,
    setPlatformNumber,
    errors,
    darkMode,
    OC,
    submitData,
    platformID,
    isCurrentTrunkOC,
}) => {
    const platformIndex = submitData.findIndex(
        (platform) => platform.platformID === platformID,
    );
    const platform = submitData[platformIndex];
    const handleSelectChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatforms = [...prev];
            newPlatforms[platformIndex] = {
                ...platform,
                operatorConnectUsageID: item.id,
            };
            return newPlatforms;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors?.usageType}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Usage Type<span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="usageType"
                    name="usageType"
                    shownValue="displayName"
                    currentId={platform?.operatorConnectUsageID}
                    handleSelectChange={handleSelectChange}
                    currentCompany={currentCompany}
                    accountScope={accountScope}
                    darkMode={darkMode}
                    data={OC}
                    validate={() => {
                        if (
                            isCurrentTrunkOC &&
                            !platform?.operatorConnectUsageID
                        ) {
                            return 'Usage Type is required for an Operator Connect number.';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Usage Type defines what a OC number can be assigned to. Please select the appropriate value for this number whether you're assigning it to Users (CallingPlanAssignment) or Resource Accounts (FirstPartyAppAssignment)"
                        ariaLabel="numbers-usage-type-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UsageTypeDropdown;
